export default __webpack_public_path__ + "static/media/cpv_80_education.42237930.svg";